import { createStore } from 'redux'

const initialState = {
      sidebarShow: true,
}

const changeState = (state = initialState, { type, ...rest }) => {
      switch (type) {
        case 'set':
          return { ...state, ...rest }
        case 'staff':
          return { ...state, ...rest }
        case 'floor':
            return { ...state, ...rest }
        case 'device':
          return { ...state, ...rest }
        case 'deviceOptions':
          return {...state, ...rest}
        default:
          return state
      }
}

const store = createStore(changeState)
export default store


